var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('el-button', _vm._g(_vm._b({ class: _vm.ptCommonButton, attrs: { "disabled": _vm.disabled, "loading": _vm.loading } }, 'el-button', _vm.pick(_vm.$attrs, ['loading', 'disabled', 'autofocus', 'native-type', 'circle']), false), _vm.$listeners), [_vm._t("default")], 2);
};
var staticRenderFns = [];

export { render, staticRenderFns };